export function getReferrer() {
  return document.referrer;
}
export function getSessionId() {
  return window.hubspot && window.hubspot.sessionId;
}